/**
 * cc-usage display format helpers.
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business cc-usage dashboard で共通利用する数値表示 formatter
 * @graph-connects none
 */

/**
 * 大きな token 値をカードや軸ラベル用に短縮表示する。
 *
 * @graph-connects none
 */
export function formatCompact(value: number): string {
  if (Math.abs(value) >= 1_000_000_000) return `${(value / 1_000_000_000).toFixed(1)}B`;
  if (Math.abs(value) >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (Math.abs(value) >= 1_000) return `${(value / 1_000).toFixed(1)}K`;
  return value.toLocaleString();
}

/**
 * token / count を locale aware に表示する。
 *
 * @graph-connects none
 */
export function formatNumber(value: number): string {
  return value.toLocaleString();
}

/** organization 名はほぼ air-closet 固定なので表示から省く。 @graph-connects none */
const AIR_CLOSET_ORG_PREFIX = 'air-closet/';

/**
 * リポジトリ別利用量の表示名を整形する。
 *
 * cc-usage に登場するリポジトリは `air-closet/cortex` のように `org/repo` 形式で、
 * organization 名は基本 air-closet 固定のため冗長になる。`air-closet/` プレフィックスを
 * 落としてリポジトリ名のみを表示する。他 organization のリポジトリは判別のため
 * `org/repo` のまま残す。
 *
 * @graph-connects none
 */
export function formatRepositoryName(repository: string): string {
  return repository.startsWith(AIR_CLOSET_ORG_PREFIX)
    ? repository.slice(AIR_CLOSET_ORG_PREFIX.length)
    : repository;
}
